/**
 * Client-side Blockdaemon SDK instance
 * Initialized directly to communicate with Blockdaemon APIs
 */
import { BdSdk } from "@blockdaemon/bd-sdk";

// Initialize BdSdk with direct configuration
// This will make API calls directly to Blockdaemon services without authentication
export const blockdaemonSDK = new BdSdk({ basePath: `${window.location.origin}/sdk` });
